import React, { useState } from "react";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
// import MenuOpenRoundedIcon from "@mui/icons-material/MenuOpenRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

const Navbar = ({
  projectRef,
  codingRef,
  homeRef,
  experianceRef,
  contactRef,
}) => {
  const [showMenu, setShowMenu] = useState(true);
  const scrollToProject = () => {
    if (projectRef.current) {
      projectRef.current.scrollIntoView({ behavior: "smooth" }); // Scroll to the Home component
    }
  };

  const scrollToCoding = () => {
    if (codingRef.current) {
      codingRef.current.scrollIntoView({ behavior: "smooth" }); // Scroll to the Home component
    }
  };
  const scrollToHome = () => {
    if (homeRef.current) {
      homeRef.current.scrollIntoView({ behavior: "smooth" }); // Scroll to the Home component
    }
  };
  const scrollToExperiance = () => {
    if (experianceRef.current) {
      experianceRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  const scrollToContact = () => {
    if (contactRef.current) {
      contactRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <div className="fixed z-50 lg:pl-20 sm: pl-6 lg:pr-20 sm: pr-6 w-full h-14 backdrop-blur-md flex justify-between items-center">
      <p
        onClick={scrollToHome}
        className="text-white font-semibold lg:text-3xl sm: text-xl mt-6 "
      >
        Pushkar
      </p>

      <div className="lg:flex gap-10 sm: hidden text-base text-white mt-4">
        <p onClick={scrollToHome} className=" cursor-pointer font-medium">
          Home
        </p>
        <p onClick={scrollToExperiance} className=" cursor-pointer font-medium">
          Experiance
        </p>
        <p onClick={scrollToCoding} className=" cursor-pointer font-medium">
          Coding
        </p>
        <p onClick={scrollToProject} className=" cursor-pointer font-medium">
          Projects
        </p>
        <p onClick={scrollToContact} className=" cursor-pointer font-medium">
          Contact
        </p>
      </div>

      <div className=" relative lg:hidden sm: flex  text-white ">
        {showMenu ? (
          <MenuRoundedIcon onClick={() => setShowMenu(!showMenu)} />
        ) : (
          <CloseRoundedIcon onClick={() => setShowMenu(!showMenu)} />
        )}

        {!showMenu && (
          <div className=" absolute top-4 right-4">
            <div className=" text-xs font-medium text-gray-800 p-4  rounded-xl flex flex-col gap-2 bg-white">
              <p
                onClick={() => {
                  scrollToHome();
                  setShowMenu(!showMenu);
                }}
                className=" cursor-pointer "
              >
                Home
              </p>
              <p
                onClick={() => {
                  scrollToExperiance();
                  setShowMenu(!showMenu);
                }}
                className=" cursor-pointer "
              >
                Experiance
              </p>
              <p
                onClick={() => {
                  scrollToCoding();
                  setShowMenu(!showMenu);
                }}
                className=" cursor-pointer "
              >
                Coding
              </p>
              <p
                onClick={() => {
                  scrollToProject();
                  setShowMenu(!showMenu);
                }}
                className=" cursor-pointer"
              >
                Projects
              </p>
              <p
                onClick={() => {
                  scrollToContact();
                  setShowMenu(!showMenu);
                }}
                className=" cursor-pointer"
              >
                Contact
              </p>
            </div>
          </div>
        )}
      </div>

      {/* </div> */}
    </div>
  );
};

export default Navbar;
